// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1FCYd","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3bS4x"};